import DashboardLayout from "@/packages/dashboard/views/DashboardLayout.vue";
import GettingStarted from "@/packages/c2bModules/GettingStarted/view/GettingStarted.vue";
const GettingStartedRoutes =[
    {
        path: '/dashboard',
        component: DashboardLayout,
        children: [
            {
                path: 'api-reference/introduction',
                component: GettingStarted,
                name: "Introduction",
                // meta: { middleware: [Auth]},
            },
            // {
            //     path: 'api-reference/introduction',
            //     component: Introduction,
            //     name: "Introduction",
            //     // meta: { middleware: [Auth]},
            // },
            // {
            //     path: 'api-reference/nomenclature',
            //     component: Nomenclature,
            //     name: "Nomenclature",
            //     // meta: { middleware: [Auth]},
            // },
        ]
    }
];
export default GettingStartedRoutes;
